<app-page-header
  title="Benachrichtigungen"
  subtitle="Bleib über Aktivitäten und wichtige Updates informiert."
  icon="notifications_active"
  variant="gradient">
</app-page-header>

<div class="apple-container apple-notifications-wrapper apple-slide-up">
  <ng-container *ngIf="(notifications$ | async) as notifications">
    <div *ngIf="notifications.length > 0; else noNotifications" class="apple-notifications-list">
      <article
        *ngFor="let note of notifications.slice().reverse()"
        class="apple-card apple-card-hover apple-notification-card"
        [ngClass]="{ unread: !note.isRead, read: note.isRead, 'apple-card-clickable': !!note.link }"
        (mouseenter)="markAsRead(note)"
        [routerLink]="note.link || undefined"
        role="article"
        aria-label="Benachrichtigung"
      >
        <div class="apple-notification-icon">
          <mat-icon>{{ note.isRead ? 'notifications' : 'notifications_active' }}</mat-icon>
        </div>
        <div class="apple-notification-content">
          <h2 class="apple-notification-title">
            {{ note.title || 'Benachrichtigung' }}
          </h2>
          <p class="apple-notification-message">
            {{ note.message }}
          </p>
          <div class="apple-notification-meta">
            <span class="apple-notification-time" *ngIf="note.createdAt">
              {{ note.createdAt | date: 'short' }}
            </span>
            <span class="apple-notification-status" [ngClass]="{ unread: !note.isRead, read: note.isRead }">
              {{ note.isRead ? 'Gelesen' : 'Ungelesen' }}
            </span>
            <button
              *ngIf="!note.isRead"
              mat-stroked-button
              color="primary"
              class="apple-button apple-button-secondary apple-button-small apple-mark-read-btn"
              (click)="onMarkAsRead($event, note)"
            >
              <mat-icon>done</mat-icon>
              Als gelesen markieren
            </button>
          </div>
        </div>
      </article>
    </div>
    <ng-template #noNotifications>
      <div class="apple-card apple-no-notifications apple-fade-in">
        <div class="apple-empty-icon">
          <mat-icon>notifications_off</mat-icon>
        </div>
        <div>
          <h2 class="apple-heading-3">Alles erledigt!</h2>
          <p class="apple-body-secondary">
            Du hast aktuell keine Benachrichtigungen.
          </p>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>
